import { DatePipe } from '@angular/common';
import { provideHttpClient, withInterceptors, withXhr } from '@angular/common/http';
import { ApplicationConfig, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';
import { authInterceptor } from '@shared/lib/core/interceptors/auth.interceptor';
import { errorInterceptor } from '@shared/lib/core/interceptors/error.interceptor';
import { routes } from '@web-app/app/app.routes';
import { API_BASE_URL } from '@web-app/app/services/typed-api';
import { environment } from '@web-app/environments/environment';
import { providePrimeNG } from 'primeng/config';

const MyPreset = definePreset(Aura, {
  components: {
    datatable: {
      // PrimeNG 22 sets a font size on cells; inherit so the table's text-xs/text-sm (tableSize) applies again
      columnTitle: {
        fontSize: 'inherit'
      },
      bodyCell: {
        fontSize: 'inherit'
      },
      columnFooter: {
        fontSize: 'inherit'
      },
      colorScheme: {
        dark: {
          row: {
            stripedBackground: '{surface.700}'
          }
        }
      }
    }
  }
});


export const appConfig: ApplicationConfig = {
  providers: [
    providePrimeNG({
      license: environment.primengLicense || undefined,
      ripple: true,
      theme: {
        preset: MyPreset,
        options: {
          darkModeSelector: '.ods-dark',
          cssLayer: {
            name: 'primeng',
            order: 'theme, base, primeng, components, utilities'
          }
        }
      }
    }),
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(withXhr(), withInterceptors([authInterceptor, errorInterceptor])),
    { provide: API_BASE_URL, useFactory: () => environment.data.baseUrl },
    provideZonelessChangeDetection(),
    provideTranslateService({
      loader: provideTranslateHttpLoader(),
    }),
    DatePipe,
  ],
};

